<template>
  <div :class="classes" :data-exist="exist">
    <div
      data-is="bc-banner"
      data-autoload="false"
      :data-ui="ui"
      :data-screen="screen"
      :data-type="type"
      :data-size="size"
      :data-force-mq="forceMq"
      :data-fixed="fixed"
      :data-expel-fixed="expelFixed"
      :data-z-index="zIndex"
      ref="banner"
    ></div>
  </div>
</template>



<script>
export default {
  props: {
    ui        : String,
    screen    : String,
    type      : String,
    size      : Object,
    forceMq   : String,
    fixed     : Boolean,
    expelFixed: Boolean,
    zIndex    : [String, Number],
  },

  data() {
    return {
      exist: false,
    }
  },

  computed: {
    classes() {
      return {
        'dn-bc-banner': true,
      }
    },
  },

  methods: {
    onExist(exist) {
      this.exist = exist;
    },
  },

  async mounted() {
    this.banner = await bcBanner.applyElement(this.$refs.banner, {
      parent: this,
      onExist: exist => { this.onExist(exist) },
    });
  },

  beforeDestroy() {
    if (this.banner) this.banner.onBeforeDestroy();
  },

  destroyed() {
    if (this.banner) this.banner.onDestroyed();
    this.banner = null;
    delete this.banner;
  },
}
</script>


// WEBPACK FOOTER //
// BcBanner.vue?2cda159d